import { environment } from "src/environments/environment"

//MARK:GENERAL
export const general_endpoint = {
    countries: '/countries',
    categories: '/categories',
    regency: '/regency',
    kantorCabang: "/cabangs",
    chatBotList: "/chatBots?parent=1",
    slideShows: "/slideShows?type=",
    province: "/location-province",
    exhibitorFilter: '/exhibitor-filter?',
    landingVideo: '/landing-videos'
}

//MARK:EVENTS
export const events_endpoint = {
    countdown: '/events/'+environment.eventId+'/countdown',
    schedules: '/events/'+environment.eventId+'/schedules',
    schedulesByRoom: '/events/'+environment.eventId+'/scheduleFilter?room_id=',
    speakers: '/events/'+environment.eventId+'/speakers',
    galleries: '/events/'+environment.eventId+'/galleries',
    promotions: '/events/'+environment.eventId+'/promotions',
    sessions: '/events/'+environment.eventId+'/sessions',
    faq_list: '/events/'+environment.eventId+'/faq',
    exhibitorCode: '/events/'+environment.eventId+'/exhibitorCode/',
    exhibitordetail: '/events/'+environment.eventId+'/exhibitors/',
    operationalTime: '/events/'+environment.eventId+'/exhibitors/{exhibitorID}/operationalTime',
    hallDetail: '/events/'+environment.eventId+'/halls/',
    kprProduct: '/events/'+environment.eventId+'/exhibitorParent',
    hallFaq: '/events/'+environment.eventId+'/halls/{hallId}/faq',
    hallCategory: '/events/'+environment.eventId+'/halls/{hallId}/categories',
    exhibitorParent: '/events/'+environment.eventId+'/exhibitorParent/',
    exhibitorProduct: '/events/'+environment.eventId+'/exhibitorProduct/',
    virtualBidding: '/events/'+environment.eventId+'/virtualBiddings/',
    biddingSessionDetail: '/events/'+environment.eventId+'/virtualBiddings/1/biddingSessions/',
    biddingCekCusNumber: '/events/'+environment.eventId+'/virtualBiddings/1/check?customer_number=',
    roomID: '/events/'+environment.eventId+'/roomsId/',
}

//MARK:LOG
export const log_endpoint = {
  slideshow: '/slideShows/{id}/click',
  exhibitorBanner: '/events/'+environment.eventId+'/exhibitors/{exhibitorID}/banners/{bannerID}/click',
  exhibitorBrochure: '/events/'+environment.eventId+'/exhibitors/{exhibitorID}/brochures/{brochuresID}/click',
  exhibitorBrochureDownload: '/events/'+environment.eventId+'/exhibitors/{exhibitorID}/brochures/{brochuresID}/download/click',
  exhibitorBtn:'/events/'+environment.eventId+'/exhibitors/{exhibitorID}/click/{btnName}',
  exhibitorProductBtn:'/events/'+environment.eventId+'/exhibitorProduct/{productID}/click/{btnName}',
  exhibitorBannerBtn: '/events/'+environment.eventId+'/exhibitors/{exhibitorID}/banners/{bannerID}/click/{btn}',
}


//MARK:USERS
export const users_endpoint = {
    users: '/users',
    change_password: '/users/change-password',
    myBrochure: '/users/files',
}

export const content_endpoint = {
    content: '/contents?key=',// insert key
}
